import { createFileRoute, Link, Outlet } from '@tanstack/react-router'
import { CircleUserRound } from 'lucide-react'

export const Route = createFileRoute('/_authenticated/_layout')({
  component: () => (
    <div className="flex w-screen flex-col">
      <header className="border-gray-light-200 flex flex-1 items-center justify-between border-b px-6 py-2 md:px-28">
        <Link to="." href="https://wp.massiliavoyages.fr/">
          <img alt="Massilia Voyages" className="h-9 md:h-12" src="/logos/massilia-logo.png" />
        </Link>
        <Link
          className="text-gray-light-600 hover:text-gray-light-900 p-2"
          to="/informations-personnelles"
        >
          <CircleUserRound className="size-6" />
        </Link>
      </header>
      <Outlet />
    </div>
  ),
})
